import { defineStore } from 'pinia'
import router from '@/router'

export const usePlayGame = defineStore('PlayGame', {
  actions: {
    playNow() {
      // TEMPORARY: always play the default game client
      window.nexon.play()
      // const isMSCW = router.currentRoute.value.path.includes('/mscw/')
      // if (isMSCW) {
      //   window.nexon.play('mscw')
      // } else {
      //   window.nexon.play()
      // }
    },
  },
})
